
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DealOffer } from '@/DealOffer'
import { TokenUser } from '@/TokenUser'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import { Plotly } from '@rleys/vue-plotly-basic'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'DealOfferListComponent',
  components: { Plotly, ModalWrapperComponent }
})
export default class DealListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public deal: DealOffer

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get devMode(): boolean { return this.$store.state.devmode }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public getNiceLowAskString(): string { return utils_topshot.getNicePriceString(this.deal.lowAskForEdition) }
  public getNiceFMVString(): string { return utils_topshot.getNicePriceString(this.deal.valueFMV) }
  public getNicePriceString(): string { return utils_topshot.getNicePriceString(this.deal.offerPrice) }
  public getNicePossibleDecimalPriceString(): string { return utils_topshot.getNicePossibleDecimalPriceString(this.deal.offerPrice)}

  public onView(deal: DealOffer) {
    const url: string = deal.getViewURL()
    window.open(url, "_blank"); 
  }
  public onGone(deal: DealOffer) {
    const url: string = deal.getViewURL()
    window.open(url, "_blank"); 
  }
  public getViewText(deal: DealOffer) {
    return 'View'
  }
  public getGoneText(deal: DealOffer) {
    return 'Gone'
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
